const DEFAULT_ATTACHMENT_TOKEN_ESTIMATION_PARAMS = {
    max_total_tokens: 500000,
    type_bytes_per_token: {
        // mime type without subtype
        text: 4,
        image: 500,
    },
    type_subtype_bytes_per_token: {
        // mime type with subtype
        'application/pdf': 200,
        'application/msword': 500,
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 500,
        'application/vnd.openxmlformats-officedocument.presentationml.presentation': 500,
    },
    default_bytes_per_token: 100,
};
export function useAttachmentTokenEstimationParams() {
    return DEFAULT_ATTACHMENT_TOKEN_ESTIMATION_PARAMS;
}
//# sourceMappingURL=useAttachmentTokenEstimationParams.js.map